export const leadTypeOptions = [
  {
    value: "Lead",
    lable: "Lead",
  },
  {
    value: "Prospect",
    lable: "Prospect",
  },
];

export const leadSourceOptions = [
  {
    value: "Website",
    label: "Website",
  },
  {
    value: "Social Media",
    label: "Social Media",
  },
  {
    value: "Referral",
    label: "Referral",
  },
  {
    value: "Trade Show",
    label: "Trade Show",
  },
];

export const leadStageOptions = [
  {
    value: "Marketing Qualified Lead",
    lable: "Marketing Qualified Lead",
  },
  {
    value: "Sales Qualified Lead",
    lable: "Sales Qualified Lead",
  },
  {
    value: "Converted",
    lable: "Converted",
  },
  {
    value: "Closed Lost",
    lable: "Closed Lost",
  },

];
